// extracted by mini-css-extract-plugin
module.exports = {"download":"_1QZ4EnR9"};